import { axios, Response } from '../index'
import { GroupUsers } from './list-group-users'

const listManagerGroupUsers = (): Response<GroupUsers[]> => {
  return axios.get('/v1/managers/profiles')
}

export default listManagerGroupUsers
